<script>
import Vue from 'vue'
import toastMixin from '../../mixins/toast'

export default Vue.extend({
    methods: {
        log() {
            if (!this.resourceInstance) {
                return false
            }
        },

        async onSubmit() {
            const notSaveable = await this.resourceInstance.validate()
            // notSaveable is object
            if (Object.keys(notSaveable).length) {
                this.createToast('b-toaster-top-center', 'danger', true, 'Error', `${notSaveable}`)
                return false
            }
            const result = await this.resourceInstance.save()
            if (!result) {
                this.createToast('b-toaster-top-center', 'danger', true, 'Error', 'Cannot Save.')
                return false
            }
            this.createToast('b-toaster-top-center', 'success', true, 'Success', 'Saved successfully.')

            return result.response && result.response.status && (result.response.status === 201 || result.response.status === 200) ? result.response.data.id : undefined
        },
        onInput(value) {
            this.$emit('input', this.resourceInstance)
        },
        getFieldValue(field, i) {
            return field
        },
    },
    props: {
        resourceInstance: {
            type: Object,
            required: false,
        },
        fieldSet: {
            type: Object,
            required: true,
        },
    },
    mixins: [toastMixin],
})
</script>

<template>
    <form @submit.prevent="onSubmit" v-if="Object.keys(fieldSet).length > 0">
        <b-form-group v-for="(field, i) in fieldSet" :key="i" :label="String(field.label || i).toUpperCase()">
            <!-- Handle nested objects -->
            <div v-if="resourceInstance && resourceInstance.attributes[i] && typeof resourceInstance.attributes[i] === 'object'">
                <b-form-group v-for="(child, j) in field" :key="j" :label="String(child.label || j).toUpperCase()">
                    <component
                        v-if="child && child.hasOwnProperty('getComponent')"
                        :is="child.getComponent(resourceInstance, i)"
                        v-model="resourceInstance.attributes[i]"
                        :value="resourceInstance.attributes[i]"
                        @input="onInput"
                        :resourceInstance="resourceInstance"
                        :field="getFieldValue(field, i)"
                        @select="child.setValue"
                        :autocomplete="'force_off_' + Math.floor(Math.random() * 100000000)"
                    />
                </b-form-group>
            </div>
            <div v-else-if="resourceInstance">
                <component
                    :is="field.getComponent(resourceInstance, i)"
                    v-model="resourceInstance.attributes[i]"
                    :value="resourceInstance.attributes[i]"
                    @input="onInput"
                    :resourceInstance="resourceInstance"
                    :field="getFieldValue(field, i)"
                    @select="field.setValue($event, resourceInstance, i)"
                    :autocomplete="'force_off_' + Math.floor(Math.random() * 100000000)"
                    :placeholder="field.placeholder"
                    :rows="field.rows"
                />
            </div>
        </b-form-group>
    </form>
</template>

<style></style>
